<template>
  <button type="button" class="back-to-top" title="Back to top" aria-label="Back to top" @click="scrollToTop">
    <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 10l4-4 4 4" /></svg>
  </button>
</template>

<script>
export default {
  name: 'BackToTop',
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 24px;
  /* Kept low so page modals (overlay z-index 1, rendered later) cover the button */
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid #200d0d;
  border-radius: 50%;
  background-color: #463333;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.back-to-top:hover {
  background-color: #2b1616;
  transform: translateY(-2px);
}

.back-to-top:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.4);
}

.back-to-top svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
